export default (node) => {
  const professionalForm = node.querySelector('[data-form-professional]');
  const customerForm = node.querySelector('[data-form-customer]');
  const professionalButton = node.querySelector('[data-button-professional]');
  const customerButton = node.querySelector('[data-button-customer]');
  const passwordShow = node.querySelector('[data-password-show]');
  const headerSignup = node.querySelector('[data-header-login-signup]');
  const headerForms = node.querySelector('[data-header-forms]');
  const signupOptions = node.querySelector('[data-signup-options]');
  const formButtonBack = node.querySelector('[data-header-forms-back]');

  const togglePasswordVisibility = () => {
    const passwordInput = node.querySelector('[data-password-input]');
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      passwordShow.textContent = passwordShow.getAttribute(
        'data-password-hide-text'
      );
    } else {
      passwordShow.textContent = passwordShow.getAttribute(
        'data-password-show-text'
      );
      passwordInput.type = 'password';
    }
  };

  const setLoginRedirect = () => {
    // check if the url parameter no-redirect is present
    const loginRedirect = node.querySelector('[data-login-redirect]');
    const urlParams = new URLSearchParams(window.location.search);
    const noRedirect = urlParams.get('no-redirect');

    if (noRedirect === 'true') {
      return;
    }

    // get the previous page url without domain
    const previousPage = document.referrer;
    const domain = window.location.origin;
    const previousPageWithoutDomain = previousPage.replace(domain, '');

    // set the login redirect url
    loginRedirect.value = previousPageWithoutDomain;
  };

  const init = () => {
    setLoginRedirect();
    professionalButton.addEventListener('click', () => {
      professionalForm.classList.remove('hidden');
      customerForm.classList.add('hidden');
      headerSignup.classList.add('hidden');
      headerForms.classList.remove('hidden');
      signupOptions.classList.add('hidden');
      const textBack = formButtonBack.dataset.headerFormsBackProfessional;
      node.querySelector('[data-button-text]').textContent = textBack;
    });

    passwordShow.addEventListener('click', togglePasswordVisibility);

    customerButton.addEventListener('click', () => {
      customerForm.classList.remove('hidden');
      professionalForm.classList.add('hidden');
      headerSignup.classList.add('hidden');
      headerForms.classList.remove('hidden');
      signupOptions.classList.add('hidden');
      const textBack = formButtonBack.dataset.headerFormsBackCustomer;
      node.querySelector('[data-button-text]').textContent = textBack;
    });

    formButtonBack.addEventListener('click', () => {
      headerSignup.classList.remove('hidden');
      headerForms.classList.add('hidden');
      signupOptions.classList.remove('hidden');
      professionalForm.classList.add('hidden');
      customerForm.classList.add('hidden');
    });
  };

  init();
};
